import PowerUp from "./powerup";

export default PowerUp;
